import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconVrStyle0 = cosmosIconCss;

const CosmosIconVr$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVr extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '04d1999dec9231b034abc1791d63ee0df851b654', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a391afbc0d0ad293cda6f84fe74d599a4e98454c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b5cbb7e2318f0cab1f9a342b75d8ddf9e960e332', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.8 6.37a22.44 22.44 0 0 0-8.49 1.69.51.51 0 0 0-.31.47v5.36c0 .205.122.39.31.47a22.64 22.64 0 0 0 6.13 1.56.5.5 0 0 0 .56-.5V15a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.38a.5.5 0 0 0 .56.5 20.122 20.122 0 0 0 6.15-1.69.49.49 0 0 0 .29-.45V8.69a.5.5 0 0 0-.29-.46 21.62 21.62 0 0 0-8.91-1.86Zm-7.08 3.82 1.93-1.93a.5.5 0 0 1 .71 0l.36.36a.5.5 0 0 1 0 .71l-1.93 1.93a.5.5 0 0 1-.7 0l-.37-.37a.5.5 0 0 1 0-.7ZM6.84 12l-.36-.36a.5.5 0 0 1 0-.71l2.71-2.71a.5.5 0 0 1 .71 0l.36.36a.5.5 0 0 1 0 .71L7.55 12a.51.51 0 0 1-.71 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconVrStyle0; }
}, [1, "cosmos-icon-vr", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-vr"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-vr":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVr$1);
            }
            break;
    } });
}

const CosmosIconVr = CosmosIconVr$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVr, defineCustomElement };
